/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, pxToRem, mediaQuery } from '@insticator/insticator-ui'; // iui-utils

/* ++++++++++ --------------- EXPORT : CONFIG CONTROLLER : STYLES --------------- ++++++++++ */
export default theme => ({
  configcontroller: {
    minHeight: pxToEm(80),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0 24px',
    [mediaQuery.customizeThinnest]: {
      flexDirection: 'column',
      '& > *': {
        marginTop: pxToRem(16)
      },
      '& > *:last-child': {
        marginBottom: pxToRem(16)
      }
    },
    '& .button:not(:first-child)': {
      marginLeft: '16px'
    },
    '& .description': {
      opacity: '0',
      animationName: 'fadeInUp',
      animationDuration: '.1s',
      animationDelay: '.3s',
      animationFillMode: 'forwards',
    },
    '& .button': {
      height: '32px',
      width: 'auto',
      padding: '0 16px',
      '& .text': {
        fontSize: pxToEm(14),
        fontWeight: 500,
        fontFamily: '"Work Sans", sans-serif;'
      }
    }
  }

});
